import { render, staticRenderFns } from "./ContractEditorFieldset.yaml?vue&type=template&id=820ac0da&component"
import script from "./ContractEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./ContractEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports